











































































import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import Candidate from '@/evaluations/entities/candidate'
import Evaluation from '@/evaluations/entities/evaluation'
import Competence from '@/competences/entities/competence'
import Judge from '@/evaluations/entities/judge'
import candidateService from '@/evaluations/services/candidate-service'
import Rating from '@/evaluations/entities/rating'
import ratingService from '@/evaluations/services/rating-service'
import { tr } from 'date-fns/locale'

@Component
export default class RatingCandidate extends Vue {
  @Prop()
  private eId!: string
  @Prop()
  private jId!: string
  @Prop()
  private cId!: string

  private evaluation: Evaluation = new Evaluation()
  private judge: Judge = new Judge()
  private candidate: Candidate = new Candidate()
  private competences: Competence[] = []
  private ratings: Rating[] = []
  private dialog: boolean = false
  private dialogRating: Rating = new Rating()

  private async saveScoresAsync() {
    await ratingService.saveScoresAsync(this.ratings)
    await this.loadRatingsAsync()
  }

  private async loadCandidateAsync() {
    this.candidate =
      (await candidateService.findOneAsync(this.cId)) || new Candidate()
  }

  private async loadRatingsAsync() {
    this.ratings = await ratingService.findForJudge(
      this.eId,
      this.jId,
      this.cId
    )
  }

  private openDialog(rating: Rating) {
    this.dialogRating = rating
    this.dialog = true
  }

  private closeDialog() {
    this.dialog = false
  }

  private async mounted() {
    await this.loadCandidateAsync()
    await this.loadRatingsAsync()
  }
}
